import { convertFileToBase64, encodeToBase64 } from '@modules/common/utils';

interface uploadFileToURLOptions {
  url: string;
  file: File;
  userID: string;
  setUploadProgress: (progress: number) => void;
  xhr: XMLHttpRequest;
  shouldSkipEncoding?: boolean;
}

export const uploadFileToURL = async ({
  file,
  setUploadProgress,
  url,
  userID,
  xhr,
  shouldSkipEncoding = false,
}: uploadFileToURLOptions) => {
  return new Promise(async function (resolve, reject) {
    xhr.open('PUT', url);

    xhr.setRequestHeader('content-type', file.type);
    xhr.setRequestHeader('x-amz-meta-filename', encodeToBase64(file.name));
    xhr.setRequestHeader('x-amz-meta-userid', userID);

    xhr.upload.addEventListener('progress', (e) => {
      const percentComplete = (e.loaded / e.total) * 100;

      setUploadProgress(Math.round(percentComplete));
    });

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        });
      }
    };

    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText,
      });
    };

    xhr.send(shouldSkipEncoding ? file : await convertFileToBase64(file));
  });
};
